import { Capacitor } from '@capacitor/core';
import {Share} from '@capacitor/share';

const isNativePlatform = () => {
  return Capacitor.isNativePlatform();
}

interface ShareOptions {
  name: string;
  url: string;
  title: string;
}
const share = async (props: ShareOptions) => {
  if(!Capacitor.isNativePlatform()) return;

  Share.share({
    title: props.name,
    url: props.url,
    dialogTitle: props.title,
  });
}

export const AppShare = {
	share,
  isNativePlatform
}